import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogPanel,
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
  Popover,
  PopoverButton,
  PopoverGroup,
  PopoverPanel,
} from "@headlessui/react";
import { IoIosArrowDown } from "react-icons/io";
import { Link } from "react-router-dom";

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 100);
  });

  return (
    <>
      <header className="flex justify-center self-stretch border-b border-solid border-gray-200_01 bg-white-a700 py-3">
        <nav
          aria-label="Global"
          className="mx-auto flex w-full max-w-6xl items-center justify-between gap-5 flex-row xl:px-0 px-5"
        >
          <div className="flex">
            <Link to="/">
              <img
                src="assets/Images/logo.png"
                alt=""
                className="w-[80px] h-[40px] object-contain"
              />
            </Link>
          </div>

          <PopoverGroup className="hidden lg:flex lg:gap-x-12">
            <Link to="/" className="flex items-center pb-[10px]">
              <p className=" text-[14px] cursor-pointer font-normal text-gray-600_01 hover: hover:text-black-900 ">
                Domov
              </p>
            </Link>

            <Link to="/modularny-system">
              <p className=" text-[14px] cursor-pointer font-normal text-gray-600_01 hover: hover:text-black-900">
                Modulárny systém
              </p>
            </Link>
            <Link to="/otazky-a-odpovede">
              <p className=" text-[14px] cursor-pointer font-normal text-gray-600_01 hover: hover:text-black-900">
                Najčastejsie otázky
              </p>
            </Link>

            <Link to="https://www.dreamsofa.sk/kontakt">
              <p
                className=" text-[14px] cursor-pointer font-normal text-gray-600_01 hover: hover:text-black-900"
                style={{ color: "red" }}
              >
                Kde kúpiť
              </p>
            </Link>
          </PopoverGroup>

          <div className="lg:w-[20%] sm:w-[45%] flex items-center gap-5 w-auto lg:justify-end">
            <div className="flex lg:hidden">
              <button
                type="button"
                onClick={() => setMobileMenuOpen(true)}
                className="inline-flex items-center justify-center rounded-md text-gray-700"
              >
                <img
                  src="assets/Images/menu.png"
                  alt=""
                  className="w-[30px] h-[30px]"
                />
              </button>
            </div>
          </div>
        </nav>
        <Dialog
          open={mobileMenuOpen}
          onClose={setMobileMenuOpen}
          className="lg:hidden"
        >
          <div className="fixed inset-0 z-10" />
          <DialogPanel className="fixed inset-y-0 right-0 z-10 w-full overflow-y-auto bg-white sm:max-w-sm border-l border-solid border-gray-200_01">
            <div className="flex items-center justify-end">
              <button
                type="button"
                onClick={() => setMobileMenuOpen(false)}
                className="inline-flex items-center justify-center rounded-md text-gray-700 p-[20px]"
              >
                <img
                  src="assets/Images/close.png"
                  alt=""
                  className="w-[30px] h-[30px]"
                />
              </button>
            </div>
            <div className="mt-6 flow-root">
              <div className="-my-6 ">
                <div className="space-y-2 py-6 gap-[10px] flex flex-col">
                  <Link to="/">
                    <p className=" text-[14px] text-black-900 px-[20px]">
                      Domov
                    </p>
                  </Link>
                  <Link to="/modularny-system">
                    <p className=" text-[14px] cursor-pointer font-normal text-gray-600_01 hover: hover:text-black-900 px-[20px]">
                      Modulárny systém
                    </p>
                  </Link>
                  <Link to="/otazky-a-odpovede">
                    <p className=" text-[14px] cursor-pointer font-normal text-gray-600_01 hover: hover:text-black-900 px-[20px]">
                      Najčastejsie otázky
                    </p>
                  </Link>
                  <Link to={"https://www.dreamsofa.sk/kontakt"}>
                    <p
                      className=" text-[14px] cursor-pointer font-normal text-gray-600_01 hover: hover:text-black-900 px-[20px]"
                      style={{ color: "red" }}
                    >
                      Kde kúpiť
                    </p>
                  </Link>
                </div>
              </div>
            </div>
          </DialogPanel>
        </Dialog>
      </header>
    </>
  );
};

export default Header;
